import { VERTICAL_SCROLL_EXTRA_OFFSET } from '../constants';
import { trackCustomEvent } from './analytics';
import { addClass, getClosesParent, hasClass, removeClass } from './generic';

/**
 * scrollToHash()
 *
 * Pomale odscrollovani na kotvu - po prijeti HASHe v URL
 */
export const scrollToHash = (): void => {
    if (window.location.hash) {
        const anchor = window.location.hash;
        if (anchor.includes('&') || !document.getElementById(anchor.substring(1))) {
            return;
        }
        console.info('URL HASH found. Scrolling to element ' + anchor);
        scrollToSelector(anchor);
        trackCustomEvent('select_content', {
            content_type: 'anchor_element',
            item_id: anchor,
        });
    }
};

/**
 * scrollToSelector()
 *
 * Pomale odscrollovani na vybrany selector vcetne zapocteni vertikalniho offsetu.
 * Offset je bud zadan formou parametru nebo se vypocte v zavislosti na vysce navigace (.navbar)
 *
 * @param selector
 * @param verticalOffset
 */
export const scrollToSelector = (selector: string, verticalOffset?: number): void => {
    const navbar = document.querySelector('.navbar-header');
    if (typeof verticalOffset === 'undefined') {
        const navBarHeaderHeight = navbar ? navbar.getBoundingClientRect().height : 0;
        verticalOffset = (navBarHeaderHeight || 100) + (VERTICAL_SCROLL_EXTRA_OFFSET || 0);
        console.log('verticalOffset', verticalOffset, navBarHeaderHeight);
    }

    const target = document.querySelector(selector);
    if (target) {
        // bez toho odlozeni to nefunguje spolehlive:
        window.setTimeout(() => {
            const elementPosition = target.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - (verticalOffset || 0);

            window.scrollTo({
                behavior: 'smooth',
                top: offsetPosition,
            });
        }, 100);
    }
};

/**
 * scrollableResponsiveTables()
 *
 * Doplni/odstrani upozorneni na scrollovatelnou responsivni tabulku
 */
export const scrollableResponsiveTables = (): void => {
    const tables = document.querySelectorAll('table');

    for (let i = 0, l = tables.length; i < l; i++) {
        const table = tables[i];
        const container = getClosesParent(table, function (el: HTMLElement) {
            return hasClass(el, 'table-responsive');
        }) as HTMLDivElement;

        if (!container) {
            return;
        }

        const currentId = container.getAttribute('data-related-id');
        if (table.getBoundingClientRect().width > container.getBoundingClientRect().width) {
            if (!currentId) {
                const newId = 'sti-' + Math.round(new Date().getTime() + Math.random() * 100);
                addClass(container, 'scrollable');
                container.setAttribute('data-related-id', newId);
                const msgEl = document.createElement('small');
                msgEl.innerHTML =
                    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>' +
                    window.__WEBSITE__.AppStrings.LNG_scrollable_responsive_table_info;
                msgEl.setAttribute('id', newId);
                msgEl.setAttribute('class', 'scrollable-table-info');
                container.appendChild(msgEl);
                const parent = container.parentNode;
                parent && parent.insertBefore(msgEl, container.nextSibling);
            }
        } else if (currentId) {
            const msgEl = document.getElementById(currentId);
            if (msgEl) {
                msgEl.remove();
            }
            removeClass(container, 'scrollable');
            container.removeAttribute('data-related-id');
        }
    }
};
